import { parseProductDescription } from "../utils/productDescription";

export default function ProductDescription({ value, className = "", ...props }) {
  const blocks = parseProductDescription(value);
  if (!blocks.length) return null;

  return (
    <div className={["product-description-copy", className].filter(Boolean).join(" ")} {...props}>
      {blocks.map((block, index) => {
        if (block.type === "bullet") {
          return (
            <ul key={`bullet-${index}`}>
              {block.items.map((item, itemIndex) => <li key={`${item}-${itemIndex}`}>{item}</li>)}
            </ul>
          );
        }
        if (block.type === "number") {
          return (
            <ol key={`number-${index}`}>
              {block.items.map((item, itemIndex) => <li key={`${item}-${itemIndex}`}>{item}</li>)}
            </ol>
          );
        }
        return <p key={`paragraph-${index}`}>{block.text}</p>;
      })}
    </div>
  );
}
